import { useEffect } from 'react'
import { useSearchParams } from 'react-router-dom'

import { useSessionStorage } from 'shared/hooks'

export default function useSignUpPath() {
  const [searchParams, setSearchParams] = useSearchParams()

  const [redirectOrigin] = useSessionStorage(
    'redirectOrigin',
    window.fallbackOrigin
  )

  const { userRegistrationSitemodelPath } = window
  const url = new URL(redirectOrigin)
  const [subdomain] = url.hostname.split('.')
  const fallbackPath =
    userRegistrationSitemodelPath[subdomain] ||
    userRegistrationSitemodelPath.default

  const [signUpPath, setSignUpPath] = useSessionStorage(
    'signUpPath',
    fallbackPath
  )

  useEffect(() => {
    const signUpPathFromParams = searchParams.get('signUpPath')
    if (signUpPathFromParams) {
      setSignUpPath(signUpPathFromParams)
      searchParams.delete('signUpPath')
      setSearchParams(searchParams, { replace: true })
    }
  }, [searchParams, setSignUpPath, setSearchParams])

  return signUpPath
}
